<template>
  <div id="app">
    <MobileHeader v-if="!isAdminPage" />
    <TopBanner v-if="!isAdminPage" @open-register="openFloatingRegister" />
    <main class="main-content" :class="{ 'with-header': !isAdminPage }">
      <router-view />
    </main>
    <FooterSection v-if="!isAdminPage" />
    <MobileFloatingBar v-if="!isAdminPage" ref="floatingBar" />
  </div>
</template>

<script>
import TopBanner from '@/components/TopBanner.vue'
import MobileFloatingBar from '@/components/MobileFloatingBar.vue'
import MobileHeader from '@/components/MobileHeader.vue'
import FooterSection from '@/components/FooterSection.vue'

export default {
  name: 'App',
  components: { TopBanner, MobileFloatingBar, MobileHeader, FooterSection },
  computed: {
    isAdminPage() {
      return this.$route.path.startsWith('/admin')
    }
  },
  methods: {
    openFloatingRegister() {
      if (this.$refs.floatingBar) {
        this.$refs.floatingBar.openRegister()
      }
    }
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.min.css');
@import url('https://cdn.jsdelivr.net/gh/webfontworld/score/SCoreDream.css');

:root {
  /* Typography — 둥근 친근한 톤 */
  --font-sans: 'Pretendard Variable', 'Pretendard', -apple-system, sans-serif;
  --font-rounded: 'S-Core Dream', 'Pretendard Variable', 'Pretendard', sans-serif;
  --font-pretendard: var(--font-sans);

  /* Legacy aliases — 모두 둥근 산세리프로 통합 */
  --font-serif-kr: var(--font-rounded);
  --font-serif-en: var(--font-rounded);
  --font-display: var(--font-rounded);
  --font-mono-disp: var(--font-sans);

  /* 두산위브더제니스 센트럴 천안 — Brand Palette (Navy/Blue) */
  --le-noir: #00061C;
  --le-ink: #0B1330;
  --le-charcoal: #1E2648;
  --le-graphite: #3C4468;
  --le-warm-grey: #6C7492;
  --le-pearl: #EEF1F8;
  --le-bone: #E1E7F4;
  --le-cream: #F5F7FC;
  --le-white: #FFFFFF;

  /* Blue accent (텍스트 / 라인 / 강조) — 로고 네이비 #000830 기반 */
  --le-champagne: #16266B;
  --le-champagne-light: #33499E;
  --le-champagne-dark: #000830;
  --le-gold-line: rgba(22, 38, 107, 0.32);
  --le-gold-line-soft: rgba(22, 38, 107, 0.16);

  /* Brand blue (alias) */
  --le-orange: #16266B;
  --le-orange-light: #33499E;
  --le-orange-dark: #000830;

  /* Legacy mapping for existing components */
  --primary: var(--le-noir);
  --primary-light: var(--le-ink);
  --primary-dark: #000000;
  --sub-color: var(--le-pearl);
  --text-color: #3A3A3A;
  --white: #ffffff;
  --font-family: var(--font-sans);
  --font-family2: var(--font-serif-en);
  --font-family4: var(--font-serif-kr);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: var(--font-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--le-ink);
  background: #ffffff;
}

html, body {
  overflow-x: hidden;
  width: 100%;
  background: #ffffff;
}

img { display: block; max-width: 100%; }

.main-content.with-header {
  padding-top: 60px;
}

body.has-top-banner .main-content.with-header {
  padding-top: 120px;
}

#app {
  overflow-x: hidden;
  width: 100%;
}
</style>
